import { Controller } from '@hotwired/stimulus';
import { useIntersection } from 'stimulus-use';

export default class extends Controller {
  static get targets() {
    return ['viewInput', 'hiddenInput'];
  }

  connect() {
    useIntersection(this);

    // labelのネイティブ動作を防止（ダブルトグル防止）
    // label内のcheckboxをクリックすると、labelのネイティブ動作と
    // bootstrap5-toggleのpointerdownの両方が発火してダブルトグルになるため
    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  appear(_entry) {
    // 既に初期化済みの場合はスキップ
    if (this.initialized) return;
    this.initialized = true;

    $(this.viewInputTarget).bootstrapToggle({
      size: 'mini',
      onlabel: '<span></span>',
      offlabel: '<span></span>',
      offstyle: 'secondary',
      style: 'ios',
    });

    $(this.viewInputTarget).on('change', () => {
      $(this.viewInputTarget).val($(this.viewInputTarget).prop('checked'));
      $(this.hiddenInputTarget).val($(this.viewInputTarget).prop('checked'));
    });
  }

  // disappear(_entry) {
  //   // console.debug('[chat][js] interaction#disappear', this.identifier, _entry)
  // }
}
